export default __webpack_public_path__ + "static/media/5.d03e6a98.jpg";